module.exports = __webpack_public_path__ + "static/media/10.23cb143e.png";